import { createSlice } from '@reduxjs/toolkit';

export const EmployeeSlice = createSlice({
  name: 'employee',
  initialState: {
    employee_list: [],
    employee: {},
    employee_select: [],
    employeeResume: {
      total: 0,
      activos: 0,
      inactivos: 0,
    },
    employeeLateResume: 0,
    employePeriodoPruebaResumen: [],
    employeesTareasPendientes: [],
    employeesCumpleanos: [],
    employeesContracts: [],
  },
  reducers: {
    setEmployesRedux: (state, { payload }) => {
      state.employee_list = payload;
    },
    setEmployeRedux: (state, { payload }) => {
      state.employee = payload;
    },
    setEmployeSelectRedux: (state, { payload }) => {
      state.employee_select = payload;
    },
    setEmployeResumenRedux: (state, { payload }) => {
      state.employeeResume = payload;
    },
    setEmployeLateResumenRedux: (state, { payload }) => {
      state.employeeLateResume = payload;
    },
    setEmployePeriodoPruebaResumenRedux: (state, { payload }) => {
      state.employePeriodoPruebaResumen = payload;
    },
    setEmployeesTareasPendientesRedux: (state, { payload }) => {
      state.employeesTareasPendientes = payload;
    },
    setEmployeesCumpleanosRedux: (state, { payload }) => {
      state.employeesCumpleanos = payload;
    },
    setEmployeesContractsRedux: (state, { payload }) => {
      state.employeesContracts = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setEmployesRedux,
  setEmployeRedux,
  setEmployeSelectRedux,
  setEmployeResumenRedux,
  setEmployeLateResumenRedux,
  setEmployePeriodoPruebaResumenRedux,
  setEmployeesTareasPendientesRedux,
  setEmployeesCumpleanosRedux,
  setEmployeesContractsRedux,
} = EmployeeSlice.actions;
